import magnifiAPIInstance from "./apiInstance";

export const ruleConfigurationAPIs = {
  getRuleConfiguration: ({ entityId, ruleId }) =>
    magnifiAPIInstance.get(`/api/v3/entities/${entityId}/rules/${ruleId}`),
  getRuleConfigurations: ({ payload, entityId }) =>
    magnifiAPIInstance.get(`/api/v3/entities/${entityId}/rules`, payload),
  updateRuleConfigurationScope: ({ payload, entityId, ruleConfigurationId }) =>
    magnifiAPIInstance.patch(`/api/v3/entities/${entityId}/rules/${ruleConfigurationId}/scope`, payload),
  updateRuleConfiguration: ({ payload, entityId, ruleConfigurationId }) =>
    magnifiAPIInstance.put(`/api/v3/entities/${entityId}/rules/${ruleConfigurationId}`, payload),
  createRuleConfiguration: ({ payload, entityId }) =>
    magnifiAPIInstance.post(`/api/v3/entities/${entityId}/rules`, payload),
  listRuleConfigurations: ({ payload, entityId }) =>
    magnifiAPIInstance.post(`/api/v3/entities/${entityId}/rules.list`, payload),
  listRuleOutputs: ({ payload, entityId }) =>
    magnifiAPIInstance.post(`/api/v3/entities/${entityId}/rule-executions.list`, payload),
  listRuleConfigurationFilters: ({ payload, entityId }) =>
    magnifiAPIInstance.post(`/api/v3/entities/${entityId}/rules.filters`, payload),
  listRuleExecutionFilters: ({ payload, entityId }) =>
    magnifiAPIInstance.post(`/api/v3/entities/${entityId}/rule-executions.filters`, payload),
  triggerRuleConfiguration: ({ payload }) => magnifiAPIInstance.post(`/api/v3/rule.trigger`, payload),
};
